import { gql } from '@apollo/client'

export const MEDIA_BUYER_LIST = gql`
    query {
        getMediaBuyers {
            id
            name
            campaigns {
                name
            }
            labels {
                name
            }
        }
    }
`

export const CREATE_MEDIA_BUYER = gql`
    mutation($input: MediaBuyerInput) {
        createMediaBuyer(input: $input) {
            id
            name
        }
    }
`

export const UPDATE_MEDIA_BUYER = gql`
    mutation($input: MediaBuyerUpdateInput) {
        updateMediaBuyer(input: $input) {
            id
            name
        }
    }
`

export const DELETE_MEDIA_BUYER = gql`
    mutation($id: String) {
        deleteMediaBuyer(id: $id) {
            result,
        }
    }
`
